<style lang="less">
/*@import "./Check.less";*/
body {
  background: #4d2421;
  color: white;
}
</style>
<template>
  <div class="container-fluid">
    <!--头部-->
    <div class="row header2 jss-transparent">
      <div class="col-lg-12 text-center">
        <!-- <img src="/static/image/tllogo.png" style="width: 40px;height: 40px;"> -->
        <span style="font-size:30px;">手持检票系统{{versionNo}}</span>
      </div>
    </div>
    <!--交互内容显示区-->
    <div class="row content">
      <!-- <div class="col-lg-12 text-center" style="font-size: 20px;">
        <span>欢迎使用手持验票系统</span>
      </div> -->
      <div class="col-lg-12 text-center" style="font-size: 20px;">
        <!-- <span>系统版本号:</span> -->
      </div>
      <div class="col-lg-12 text-center" style="padding-top: 30px;font-size: 20px;">
        <div id="message">{{message}}</div>
        <div>{{checkTime}}</div>
      </div>
    </div>

    <!--尾部-->
    <div class="row jss-transparent navbar navbar-default navbar-fixed-bottom" style="height:60px;font-size:14px;padding-left:15px">
		<div class="col-lg-12" style="line-height: 30px;">本机序列号：
			<span>{{devSn}}</span>
			<span style="margin-left:15px">{{versionNo}}</span>
		</div>
		<div class="col-lg-12">
			<span>{{gateInfo.store_name}}</span>
		</div>
    </div>
  </div>
</template>

<script>
require("!style-loader!css-loader!less-loader!./HandCheck.less");

import { loadAudioSrc, getSignReqData } from "../../assets/js/jssFunction";
import * as deviceOperate from "../../assets/js/deviceOperate";
import { setCallBackFun } from "../../assets/js/devcieCallback";
import { DEVICE_CODE } from "../../assets/js/config";

export default {
  data() {
    return {
      message: "正在进行系统初始化。。。",
      checkTime: "",
      devSn: "",
      versionNo: "V3006",
      gateInfo: { store_name: "未获取" },
      checkFlag: true
    };
  },

  mounted: function() {
    global.LOCAL_DATA.devInfo.checkFlag = false;
    try {
      this.init();
    } catch (e) {
      this.message = "系统初始化失败";
    }
  },

  methods: {
    init: function() {
      deviceOperate.openDevice(DEVICE_CODE.DT_CODE, "", "", "");
      deviceOperate.getDev().BRStartRead(DEVICE_CODE.DT_CODE, 0);
      deviceOperate.writeAppLog(
        4,
        "二维码设备打开状态：" +
          deviceOperate.getDev().BRStartRead(DEVICE_CODE.DT_CODE, 0)
      );
      deviceOperate.openDevice(DEVICE_CODE.DT_MODBUS, "", "", "");
	  setCallBackFun(this.callBack);
      //todo 序列号验证，终端信息初始化
      global.LOCAL_DATA.devInfo.devSn = deviceOperate.getDev().GetHDSN();
					//  global.LOCAL_DATA.devInfo.devSn = "B1AF39982086F954";
					
      this.devSn = global.LOCAL_DATA.devInfo.devSn;
      let reqData = getSignReqData();
      let that = this;
      let url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/getGateInfo";
      } else {
        url =
          this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/getGateInfo";
	  }
      this.$http.post(url,JSON.stringify(reqData),this.GlobalConfig.APP_CONFIG.HEADERS)
        .then(function(response) {
          if (response.data.status == "success") {
            that.message = "请扫描票券上的二维码验票";
            global.LOCAL_DATA.systemInfo = response.data.systemInfo;
            that.gateInfo = response.data.gateInfo;
            loadAudioSrc(
              "系统初始化成功，请将票券上的二维码放在扫码器前扫码验票"
            );
          } else {
            that.message = response.data.msg;
            loadAudioSrc(
              "系统初始化失败，失败原因：" + that.message + "，正在重试初始化"
            );

            setTimeout(function() {
              that.init();
            }, 10000);
          }
        })
        .catch(function(error) {
          that.message = "网络异常，正在重新获取配置信息";
          if (that && !that._isDestroyed) {
            setTimeout(function() {
              if (that && !that._isDestroyed) that.init();
            }, 10000);
          }
        });
    },

    callBack: function(DeviceID, UserEvtID, RetCode, RetMsg) {
      switch (DeviceID) {
        //二维码阅读器
        case DEVICE_CODE.DT_CODE:
          this.onCodeEvent(UserEvtID, RetCode, RetMsg);
          break;
      }
    },

    test: function() {
      this.onCodeEvent("", "", "JS0033_001_JS0033151799418200");
      //                this.onCodeEvent("","","employee_ff8080815fb4bfc501611bdfcfea0392");
    },

    onCodeEvent: function(UserEvtID, RetCode, RetMsg) {
      let that = this;
      setTimeout(function() {
        if (global.LOCAL_DATA.devInfo.checkFlag) {
          return;
        }
        global.LOCAL_DATA.devInfo.checkFlag = true;
        loadAudioSrc("正在验票");
        if (RetMsg.indexOf("employee") >= 0) {
          that.message = "员工验码";
          that.employeeCheck(RetMsg);
        } else {
          that.message = "正在验票";
          that.check(RetMsg);
        }
      }, 500 * parseInt(Math.random()));
    },

    msgRestore: function() {
      let that = this;
      setTimeout(function() {
        that.message = "请扫描票券上二维码验票";
      }, 2000);
    },

    employeeCheck: function(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;
      let that = this;
         let reqData = getSignReqData();
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.qr_code = qrCode;
      let url = "";
      if (reqData.sign == "") {
        url =
          this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/employeeCheck";
      } else {
        url =
          this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/employeeCheck";
      }
      this.$http
        .post(
          url,
          JSON.stringify(reqData),
          this.GlobalConfig.APP_CONFIG.HEADERS
        )
        .then(function(response) {
          if (response.data.status == "success") {
            that.message = response.data.msg;
            loadAudioSrc(that.message);
            //开闸
            //                            deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 3000);
            that.msgRestore();
          } else {
            that.message = response.data.msg;
            loadAudioSrc(that.message);
            that.msgRestore();
          }

          setTimeout(function() {
            that.checkFlag = true;
            global.LOCAL_DATA.devInfo.checkFlag = false;
          }, 500);
        })
        .catch(function(error) {
          global.LOCAL_DATA.devInfo.checkFlag = false;
          that.message = "网络异常，验票失败,请重试";
          that.checkFlag = true;
          loadAudioSrc(that.message);
        });
    },

    //扫码验票
    check: function(qrCode) {
      if (!this.checkFlag) return;
      this.checkFlag = false;
      let that = this;
         let reqData = getSignReqData();
      reqData.gate_uid = this.gateInfo.gate_uid;
      reqData.gate_type = this.gateInfo.gate_type;
      reqData.enterprise_uid = this.gateInfo.enterprise_uid;
      reqData.store_uid = this.gateInfo.store_uid;
      reqData.qr_code = qrCode;
      let url = "";
      if (reqData.sign == "") {
        url = this.GlobalConfig.APP_CONFIG.BASE_API_HOST + "/Check/ticketCheck";
      } else {
        url =
          this.GlobalConfig.APP_CONFIG.BASE_API3_HOST + "/Check/ticketCheck";
      }
      this.$http
        .post(
          url,
          JSON.stringify(reqData),
          this.GlobalConfig.APP_CONFIG.HEADERS
        )
        .then(function(response) {
          if (response.data.status == "success") {
            that.message = response.data.msg;
            loadAudioSrc(that.message);
            //开闸
            //                            deviceOperate.getDev().MBSwitch(DEVICE_CODE.DT_MODBUS, 1, 0, 3000);
            that.msgRestore();
          } else {
            that.message = response.data.msg;
            loadAudioSrc(that.message);
            that.msgRestore();
          }
          setTimeout(function() {
            that.checkFlag = true;
            global.LOCAL_DATA.devInfo.checkFlag = false;
          }, 500);
        })
        .catch(function(error) {
          global.LOCAL_DATA.devInfo.checkFlag = false;
          that.message = "网络异常，验票失败,请重试";
          that.checkFlag = true;
          loadAudioSrc(that.message);
          that.msgRestore();
        });
    }
  }
};
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/views/handCheck/HandCheck2.vue